import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAppSelector } from '../../store/hooks'

interface AdminRouteProps {
  children: React.ReactNode
}

/**
 * Protected route component for admin pages
 * Redirects to /admin/login if not authenticated
 */
const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { isAdminAuthenticated } = useAppSelector((state) => state.adminAuth)

  if (!isAdminAuthenticated) {
    return <Navigate to="/admin/login" replace />
  }

  return <>{children}</>
}

export default AdminRoute
